export const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '😡', '🔥', '👏']

const list = (value = '') => String(value).split(/\s+/).filter(Boolean)

export const EMOJI_SETS = [
    {
        key: 'faces',
        title: 'Смайлики',
        icon: '😀',
        items: list(`
            😀 😃 😄 😁 😆 😅 😂 🤣 😊 😇 🙂 🙃 😉 😌 😍 🥰
            😘 😚 😋 😛 😜 🤪 😝 🤑 🤗 🤭 🤫 🤔 🤐 🤨 😐 😑
            😶 😏 😒 🙄 😬 😔 😪 😴 😷 🤒 🤕 🤢 🤧 🥵 🥶 🥴
            😵 🤯 🤠 🥳 😎 🤓 🧐 😕 😟 🙁 😮 😲 😳 🥺 😢 😭
            😱 😤 😡 🤬 😈 💀 💩 🤡 👻 🙈 🙉 🙊
        `),
    },
    {
        key: 'gestures',
        title: 'Жесты и люди',
        icon: '👍',
        items: list(`
            👍 👎 👌 ✌️ 🤞 🤟 🤘 🤙 👈 👉 👆 👇 ☝️ ✋ 🤚 👋
            👏 🙌 👐 🤲 🤝 🙏 ✍️ 💪 👀 👂 🧠 👤 👥 🙋 🤷 🤦
            🙅 🙆 💁 🏃 🚶
        `),
    },
    {
        key: 'symbols',
        title: 'Сердца и знаки',
        icon: '❤️',
        items: list(`
            ❤️ 🧡 💛 💚 💙 💜 🖤 💔 💕 💞 💖 💘 💯 🔥 ✨ ⭐
            🌟 ⚡ 💥 💫 🎉 🎊 🎁 🏆 🥇 ✅ ❌ ❗ ❓ ⚠️ ⛔ 🚫
            ➕ ➖ ✔️ 🔔 🔕 💤 💬 🆗 🆕 🔝
        `),
    },
    {
        key: 'nature',
        title: 'Животные и природа',
        icon: '🐶',
        items: list(`
            🐶 🐱 🐭 🐰 🦊 🐻 🐼 🐨 🐯 🦁 🐮 🐷 🐸 🐵 🐔 🐧
            🐦 🦅 🐴 🐝 🦋 🐢 🐟 🌹 🌷 🌸 🌻 🌲 🌳 🍀 🍁 ☀️
            🌙 ☁️ ❄️ 🌈 ☔ 🌍
        `),
    },
    {
        key: 'food',
        title: 'Еда и напитки',
        icon: '🍏',
        items: list(`
            🍏 🍎 🍊 🍋 🍌 🍉 🍇 🍓 🍒 🍑 🍍 🥝 🍅 🥑 🥕 🌽
            🍞 🧀 🍳 🍔 🍟 🍕 🌭 🥗 🍝 🍜 🍣 🍰 🎂 🍫 🍩 🍪
            ☕ 🍵 🍺 🍷 🥂 🍾
        `),
    },
    {
        key: 'work',
        title: 'Работа и предметы',
        icon: '💼',
        items: list(`
            💼 📁 📂 📄 📝 📌 📎 ✂️ 📏 📐 🔨 🔧 ⚒️ 🛠️ ⚙️ 🧱
            📦 🧾 💰 💵 💳 📈 📉 📊 📅 ⏰ ⏳ 📞 ☎️ 📱 💻 🖨️
            📷 🎥 🔍 🔑 🔒 🔓 💡 🔋 ✉️ 📧 📍 🏷️ ✏️ 🗑️
        `),
    },
    {
        key: 'travel',
        title: 'Транспорт и места',
        icon: '🚗',
        items: list(`
            🚗 🚕 🚌 🚚 🚛 🚜 🏍️ 🚲 ✈️ 🚀 🚢 ⛽ 🚧 🚦 🏠 🏢
            🏭 🏗️ ⛪ 🗺️ 🧭 ⛰️ 🏖️ 🌅
        `),
    },
]

const getId = (value) => String(value?._id || value?.id || value || '')

export const normalizeReactions = (value) => {
    if (!Array.isArray(value)) return []

    const result = []

    value.forEach((item) => {
        const emoji = String(item?.emoji || '').trim()
        if (!emoji) return

        const userIds = Array.isArray(item?.userIds)
            ? item.userIds.map(getId).filter(Boolean)
            : []
        const count = Math.max(userIds.length, Math.round(Number(item?.count || 0)))

        if (count > 0) result.push({ emoji, count, userIds })
    })

    return result
}

export const getMyReaction = (reactions, userId) => {
    const meId = getId(userId)
    if (!meId) return ''

    return normalizeReactions(reactions)
        .find((item) => item.userIds.includes(meId))?.emoji || ''
}

export const applyMyReaction = (reactions, userId, emoji) => {
    const meId = getId(userId)
    const cleanEmoji = String(emoji || '').trim()
    const current = normalizeReactions(reactions)

    if (!meId || !cleanEmoji) return current

    const mine = getMyReaction(current, meId)
    const cleaned = current
        .map((item) => (
            item.userIds.includes(meId)
                ? {
                    ...item,
                    count: Math.max(0, item.count - 1),
                    userIds: item.userIds.filter((id) => id !== meId),
                }
                : item
        ))
        .filter((item) => item.count > 0)

    if (mine === cleanEmoji) return cleaned

    const existing = cleaned.find((item) => item.emoji === cleanEmoji)
    if (existing) {
        return cleaned.map((item) => (
            item.emoji === cleanEmoji
                ? { ...item, count: item.count + 1, userIds: [...item.userIds, meId] }
                : item
        ))
    }

    return [...cleaned, { emoji: cleanEmoji, count: 1, userIds: [meId] }]
}
